import React, { useEffect, useState, useRef } from "react";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import {
  Container,
  Row,
  Col,
  Card,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import Link from "next/link";
import styles from "./styles.module.scss";
import NewsTag from "../../.sourceflow/news_tag.json";
import SearchIcon from "/public/site-assets/svg/black-magnifying-glass.svg";
import { useRouter } from "next/router";

export default function AllBlogs({
  global,
  pathPrefix,
  customClass = "",
  post,
  pagePrefix = "insights/",
  tagName,
  ParentNews = false,
  locale,
  cardPagePrefix = "insights/",
  enableFilterBy = true,
  heading,
}) {
  const router = useRouter();

  const [searchValue, setSearchValue] = useState("");
  const [filteredPosts, setFilteredPosts] = useState(post);
  const [visiblePosts, setVisiblePosts] = useState(8); // Updated to 8 for consistency
  const [showMore, setShowMore] = useState(true);

  const handleSearchChange = (event) => {
    const newValue = event.target.value;
    setSearchValue(newValue);
    filterPosts(newValue);
  };

  const filterPosts = (keyword) => {
    const lowerCaseKeyword = keyword.toLowerCase();
    const filtered = post.filter((postItem) => {
      const tagString = Array.isArray(postItem.tag)
        ? postItem.tag.join(" ")
        : postItem.tag?.en || "";
      return (
        postItem.title?.toLowerCase().includes(lowerCaseKeyword) ||
        tagString.toLowerCase().includes(lowerCaseKeyword)
      );
    });
    setFilteredPosts(filtered);
    setVisiblePosts(8);
  };

  const loadMore = () => {
    setVisiblePosts(visiblePosts + 4);
    if (visiblePosts + 4 >= filteredPosts.length) {
      setShowMore(false);
    }
  };

  useEffect(() => {
    if (filteredPosts) {
      setShowMore(filteredPosts.length > visiblePosts);
    }
  }, [filteredPosts, visiblePosts]);

  useEffect(() => {
    setFilteredPosts(post);
    setVisiblePosts(8);
  }, [router.asPath, post]);

  return (
    <section className={`${styles.root} ${customClass}`}>
      <Container>
        {/* --- This is the corrected filter bar --- */}
        {enableFilterBy && (
          <div className="filters d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-4">
            {/* Left Group: Filter Dropdown */}
            <div className="d-flex flex-wrap align-items-center">
              <label className="me-4 mb-2 mb-md-0">Filter by</label>

              {/* Dropdown 1: Corrected to use Next.js Link and absolute paths */}
              <div className="d-flex me-md-4 filter-item">
                <UncontrolledDropdown>
                  <DropdownToggle>{`${
                    ParentNews ? "Category / topic" : tagName
                  }`}</DropdownToggle>
                  <DropdownMenu>
                    {NewsTag?.category_values.map((item, index) => (
                      <Link
                        key={index}
                        href={`/${locale ? locale : ""}${
                          item.title.en === tagName
                            ? "insights" // Resets to the main insights page
                            : `${pagePrefix}${item.url_slug}`
                        }`}
                        passHref
                      >
                        <DropdownItem>{`${
                          item.title.en === tagName ? "All" : item.title.en
                        }`}</DropdownItem>
                      </Link>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              {/* Dropdown 2: Also uses Next.js Link and absolute paths */}
              {/* <div className="d-flex me-md-4 filter-item">
                <UncontrolledDropdown>
                  <DropdownToggle>{`${
                    ParentNews ? "Show All" : tagName
                  }`}</DropdownToggle>
                  <DropdownMenu>
                    {NewsTag?.category_values
                      .filter((tag) => tag.hide_from_list?.en !== true)
                      .map((item, index) => (
                        <Link
                          key={index}
                          href={`/${locale ? locale : ""}${
                            item.title.en === tagName
                              ? "insights"
                              : `${pagePrefix}${item.url_slug}`
                          }`}
                          passHref
                        >
                          <DropdownItem>{`${
                            item.title.en === tagName
                              ? "Show All"
                              : item.title.en
                          }`}</DropdownItem>
                        </Link>
                      ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div> */}
            </div>

            {/* Right Group: Search Bar */}
            <div className="position-relative search mt-3 mt-md-0">
              <input
                type="text"
                id="search"
                placeholder="Keyword search"
                onChange={handleSearchChange}
                value={searchValue}
              />
              <span className="search-icon d-inline-block position-absolute">
                <SearchIcon />
              </span>
            </div>
          </div>
        )}

        <Row className="isotope-grid">
          {filteredPosts.slice(0, visiblePosts).map((postItem, index) => (
            <Col
              md={3}
              className={`item ${
                Array.isArray(postItem.tag)
                  ? postItem.tag.join(" ").toLowerCase().replaceAll(",", "")
                  : ""
              } mb-4`}
              key={index}
            >
              <Card className="overflow-hidden h-100">
                <Link
                  href={
                    postItem.external_campaign
                      ? postItem.external_campaign
                      : `/${locale ? locale : ""}${cardPagePrefix}${
                          postItem.url_slug
                        }`
                  }
                >
                  <a
                    className="d-flex flex-wrap justify-content-between h-100"
                    target={postItem.external_campaign ? "_blank" : "_self"}
                  >
                    <div className="position-relative">
                      <SourceFlowImage
                        src={
                          postItem?.image
                            ? postItem.image
                            : "/site-assets/placeholders/img-placeholder.jpg"
                        }
                        size="800x500"
                        alt={postItem?.title}
                        className="card-img"
                      />
                      {postItem?.tag?.length >= 1 && (
                        <div className="position-absolute post-tag">
                          {postItem.tag?.map((tag, index) => (
                            <span
                              className="tertiary-bg text-black d-inline-block px-2 rounded-3 me-2 mb-2 text-nowrap"
                              key={index}
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="conteWrapper p-3 h-100">
                      <div>
                        <p className="post-title">
                          <strong>{postItem?.title}</strong>
                        </p>
                        {postItem?.short_description && (
                          <p className="post-description">
                            {postItem.short_description}
                          </p>
                        )}
                        {postItem?.salary_package && (
                          <p className="post-salary">
                            {postItem?.salary_package}
                          </p>
                        )}
                      </div>
                      <span>Read More</span>
                    </div>
                  </a>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>

        {showMore && (
          <div className="text-center mt-4">
            <button
              className="primaryBtn no-arrow border-0 m-0"
              onClick={loadMore}
            >
              Load more
            </button>
          </div>
        )}
      </Container>
    </section>
  );
}
